<script>
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'HelpPopup',
  components: { BasePopup },
  props: {
    guide: String,
  },
  data() {
    return {
      isOpened: false,
      isExpanded: false,
    };
  },
}
</script>

<template lang="pug">
  .b-help-popup
    button._btn(@click="isOpened = true")
      Icon(name="question-circle" pointer colored)
    BasePopup._popup(@close="isOpened = false" v-if="isOpened")
      ._popup-content
        ._preview
          slot
        ._buttons
          Btn(v-if="$slots.details" @click="isExpanded = !isExpanded") {{ isExpanded ? 'Свернуть' : 'Подробнее' }}
          Btn(v-if="guide" :href="guide" target="_blank" green) Видео-гайд
        ._details(v-if="isExpanded && $slots.details")
          slot(name="details")
</template>

<style scoped lang="scss">
.help-popup {
  display: flex;
  align-items: center;

  &__btn {
    display: flex;
    align-items: center;
    background: transparent;

    svg {
      color: var(--color-dark-gray);
      width: 1em;
      height: 1em;
    }
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__popup-content {
    font-size: 16px;
    font-weight: 400;
    width: 600px;
    text-align: left;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    ::v-deep {
      h2 {
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      h3 {
        margin-top: 20px;
        font-size: 20px;
        margin-bottom: 10px;
        font-weight: 500;
      }

      p {
        margin-bottom: 10px;
      }

      ul, ol {
        margin-bottom: 10px;
        padding-left: 25px;
      }
    }
  }
}
</style>
